var map = {
	"./EN_US/10_reducedInequality.png": "a181",
	"./EN_US/11_sustainableCitiesAndCommunities.png": "2c20",
	"./EN_US/12_responsibleConsumptionAndProduction.png": "1a3c",
	"./EN_US/13_climateAction.png": "d80e",
	"./EN_US/14_lifeBelowWater.png": "87de",
	"./EN_US/15_lifeOnLand.png": "c488",
	"./EN_US/16_peaceJusticeAndStrongInstitutions.png": "3b8de",
	"./EN_US/17_partnershipForTheGoals.png": "b7a7",
	"./EN_US/1_noPoverty.png": "4fa5",
	"./EN_US/2_zeroHunger.png": "0946",
	"./EN_US/3_goodHealthAndWellBeing.png": "7674",
	"./EN_US/4_qualityEducation.png": "f96a",
	"./EN_US/5_genderEquality.png": "1ede",
	"./EN_US/6_cleanWaterAndSanitation.png": "f917",
	"./EN_US/7_affordableAndCleanEnergy.png": "bd91",
	"./EN_US/8_decentWorkAndEconomicGrowth.png": "f056",
	"./EN_US/9_industryInnovationAndInfrastructure.png": "4edf",
	"./EN_US/affordableAndCleanEnergy.png": "161f",
	"./EN_US/cleanWaterAndSanitation.png": "3026",
	"./EN_US/climateAction.png": "35d6",
	"./EN_US/decentWorkAndEconomicGrowth.png": "0220",
	"./EN_US/genderEquality.png": "3d9a",
	"./EN_US/goodHealthAndWellBeing.png": "4a93",
	"./EN_US/industryInnovationAndInfrastructure.png": "03e4",
	"./EN_US/lifeBelowWater.png": "2f58",
	"./EN_US/lifeOnLand.png": "53f3",
	"./EN_US/noPoverty.png": "315c",
	"./EN_US/partnershipForTheGoals.png": "7030",
	"./EN_US/peaceJusticeAndStrongInstitutions.png": "5a4c",
	"./EN_US/qualityEducation.png": "4f23",
	"./EN_US/reducedInequality.png": "e473",
	"./EN_US/responsibleConsumptionAndProduction.png": "e8304",
	"./EN_US/sustainableCitiesAndCommunities.png": "adfb",
	"./EN_US/zeroHunger.png": "d12b",
	"./ES_AR/10_reducedInequality.png": "a2f7",
	"./ES_AR/11_sustainableCitiesAndCommunities.png": "f171",
	"./ES_AR/12_responsibleConsumptionAndProduction.png": "b321",
	"./ES_AR/13_climateAction.png": "ccc5",
	"./ES_AR/14_lifeBelowWater.png": "86f1",
	"./ES_AR/15_lifeOnLand.png": "9f6c",
	"./ES_AR/16_peaceJusticeAndStrongInstitutions.png": "aa45",
	"./ES_AR/17_partnershipForTheGoals.png": "a69c",
	"./ES_AR/1_noPoverty.png": "73e9",
	"./ES_AR/2_zeroHunger.png": "1d1a",
	"./ES_AR/3_goodHealthAndWellBeing.png": "cba5",
	"./ES_AR/4_qualityEducation.png": "62a6",
	"./ES_AR/5_genderEquality.png": "a231",
	"./ES_AR/6_cleanWaterAndSanitation.png": "ce76",
	"./ES_AR/7_affordableAndCleanEnergy.png": "277f",
	"./ES_AR/8_decentWorkAndEconomicGrowth.png": "2345",
	"./ES_AR/9_industryInnovationAndInfrastructure.png": "137c",
	"./ES_AR/affordableAndCleanEnergy.png": "0fb1",
	"./ES_AR/cleanWaterAndSanitation.png": "ad12",
	"./ES_AR/climateAction.png": "b8a7",
	"./ES_AR/decentWorkAndEconomicGrowth.png": "62b3",
	"./ES_AR/genderEquality.png": "7794",
	"./ES_AR/goodHealthAndWellBeing.png": "9547",
	"./ES_AR/industryInnovationAndInfrastructure.png": "9068",
	"./ES_AR/lifeBelowWater.png": "f77f",
	"./ES_AR/lifeOnLand.png": "642d",
	"./ES_AR/noPoverty.png": "84d0",
	"./ES_AR/partnershipForTheGoals.png": "0fcd",
	"./ES_AR/peaceJusticeAndStrongInstitutions.png": "3002",
	"./ES_AR/qualityEducation.png": "8981",
	"./ES_AR/reducedInequality.png": "b7f9",
	"./ES_AR/responsibleConsumptionAndProduction.png": "ee4e",
	"./ES_AR/sustainableCitiesAndCommunities.png": "4c82",
	"./ES_AR/zeroHunger.png": "50fd",
	"./ES_CA/10_reducedInequality.png": "4722",
	"./ES_CA/11_sustainableCitiesAndCommunities.png": "cc28",
	"./ES_CA/12_responsibleConsumptionAndProduction.png": "62aa",
	"./ES_CA/13_climateAction.png": "00a9",
	"./ES_CA/14_lifeBelowWater.png": "aef1",
	"./ES_CA/15_lifeOnLand.png": "db65",
	"./ES_CA/16_peaceJusticeAndStrongInstitutions.png": "7ada",
	"./ES_CA/17_partnershipForTheGoals.png": "298d",
	"./ES_CA/1_noPoverty.png": "d946",
	"./ES_CA/2_zeroHunger.png": "bc19",
	"./ES_CA/3_goodHealthAndWellBeing.png": "6c79",
	"./ES_CA/4_qualityEducation.png": "5973",
	"./ES_CA/5_genderEquality.png": "5ead",
	"./ES_CA/6_cleanWaterAndSanitation.png": "2294",
	"./ES_CA/7_affordableAndCleanEnergy.png": "77cf",
	"./ES_CA/8_decentWorkAndEconomicGrowth.png": "17f1",
	"./ES_CA/9_industryInnovationAndInfrastructure.png": "e982",
	"./ES_CA/affordableAndCleanEnergy.png": "d3fd",
	"./ES_CA/cleanWaterAndSanitation.png": "a6ef",
	"./ES_CA/climateAction.png": "f3e5",
	"./ES_CA/decentWorkAndEconomicGrowth.png": "e4d6",
	"./ES_CA/genderEquality.png": "ae1a",
	"./ES_CA/goodHealthAndWellBeing.png": "d0ce",
	"./ES_CA/industryInnovationAndInfrastructure.png": "0bfe",
	"./ES_CA/lifeBelowWater.png": "be8f",
	"./ES_CA/lifeOnLand.png": "49bc",
	"./ES_CA/noPoverty.png": "be8d",
	"./ES_CA/partnershipForTheGoals.png": "b967",
	"./ES_CA/peaceJusticeAndStrongInstitutions.png": "56c9",
	"./ES_CA/qualityEducation.png": "091e",
	"./ES_CA/reducedInequality.png": "b7cc",
	"./ES_CA/responsibleConsumptionAndProduction.png": "ce66",
	"./ES_CA/sustainableCitiesAndCommunities.png": "c4b1",
	"./ES_CA/zeroHunger.png": "a6d2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e04d";